import React, { Component } from 'react'
import Flip from 'react-reveal/Flip'

import 'font-awesome/css/font-awesome.min.css';

import ModalZeroIncident from './modal-zero-incident'
import ModalTotalQualityControl from './modal-total-quality-control'
import ModalEquipmentMaterial from './modal-equipment-material'
import ModalEnterpriseServices from './modal-enterprise-services'
import ModalForwardLooking from './modal-forward-looking'
import ModalBringYourOwnChallenges  from './modal-bring-your-own-challenges'

export class    CategorySection extends Component {
    render() {
        return (
            <section className="feature-section" id="category">
                <div className="shape">
                        <img src={require("../../assets/image/landing-1-shape.svg")} alt="" />
                    {/* <svg width="1903px" height="110px" viewBox="0 0 1903 110" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                    <title>Path 3</title>
                    <desc>Created with Sketch.</desc>
                    <g id="Pages" stroke="none" stroke-width="1" fill="#005bea" fill-rule="evenodd">
                        <g id="01-SaaS-Application" transform="translate(0.000000, -801.000000)" fill="#005bea">
                            <g id="Features" transform="translate(-132.000000, 738.000000)">
                                <path d="M96.8335342,4.80171458e-15 L96.8335342,25.5632762 C-39.2535138,75.1552579 -31.9009611,97.1810434 118.891192,91.6406326 C345.079422,83.3300164 738.67329,158.625979 1056.08837,120.521234 C1373.50345,82.4164899 1894.3422,25.7658781 2074,99.5753135 L2074,154.955767 C1096.4456,179.014744 444.74266,179.014744 118.891192,154.955767" id="Path-3"></path>
                            </g>
                        </g>
                    </g>
                    </svg> */}
                </div>
                <div className="container">
                    <div className="section-title text-center">
                        <h2>Categories</h2>
                    </div>
                    <div className="row mb-d-30">
                        <Flip left>
                            <div className="col-md-6 col-lg-4 mb--30">
                                <div className="feature-card">
                                    <div className="card-icon">
                                        <i className="fa fa-ban"></i>
                                    </div>
                                    <div className="card-content">
                                        <h3>Less to Zero Incident</h3>
                                        <p>Solusi yang dapat mendukung terciptanya lingkungan kerja yang lebih aman.</p>
                                        
                                        <ModalZeroIncident/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb--30">
                                <div className="feature-card">
                                    <div className="card-icon">
                                        <i className="fa fa-cogs"></i>
                                    </div>
                                    <div className="card-content">
                                        <h3>Total Quality Control</h3>
                                        <p>Solusi yang mendukung tercapainya No Defect dan produk yang selalu berkualitas. </p>
                                        <ModalTotalQualityControl/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb--30">
                                <div className="feature-card">
                                    <div className="card-icon">
                                        <i className="fa fa-wrench"></i>
                                    </div>
                                    <div className="card-content">
                                        <h3>Equipment & Material Management</h3>
                                        <p>Solusi tentang utilitasi tools dan material di bidang konstruksi. </p>
                                        <ModalEquipmentMaterial />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb--30">
                                <div className="feature-card">
                                    <div className="card-icon">
                                        <i className="fa fa-briefcase"></i>
                                    </div>
                                    <div className="card-content">
                                        <h3>Enterprise Services</h3>
                                        <p>Solusi untuk menjaga agar perusahaan tetap kompetitif dalam operasional bisnis.</p>
                                        <ModalEnterpriseServices/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb--30">
                                <div className="feature-card">
                                    <div className="card-icon">
                                        <i className="fa fa-search-plus"></i>
                                    </div>
                                    <div className="card-content">
                                        <h3>Forward Looking</h3>
                                        <p>Solusi secara umum yang dapat mendorong atau mempercepat pemanfaatan teknologi terkini. </p>
                                        <ModalForwardLooking />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 mb--30">
                                <div className="feature-card">
                                    <div className="card-icon">
                                        <i className="fa fa-lightbulb-o"></i>
                                    </div>
                                    <div className="card-content">
                                        <h3>Bring your Own Challenges</h3>
                                        <p>Ada ide menarik lainnya yang berkaitan dengan dunia konstruksi ? </p>
                                        <ModalBringYourOwnChallenges />
                                    </div>
                                </div>
                            </div>
                        </Flip>
                    </div>
                </div>
                
            </section>
        )
    }
}

export default CategorySection
